module.exports = __webpack_public_path__ + "static/media/logo.7b8d7bd9.png";